import * as React from 'react';
import { Button } from 'Src/components/Button/Button';

type Props = {
  title: string;
  programmeName?: string;
  description?: string;
  backText?: string;
  onBackClick: () => void;
  rightSlot?: React.ReactNode;
};

export const ClubProgrammePageHeader: React.FC<Props> = ({
  title,
  programmeName,
  description,
  backText = 'Back',
  onBackClick,
  rightSlot
}) => {
  return (
    <div className="cpPageHeader">
      <div className="cpPageHeaderMain">
        <button type="button" className="cpBackLink" onClick={onBackClick}>
          <span aria-hidden="true">‹</span>
          {backText}
        </button>

        <div className="cpPageTitleRow">
          <h1>{title}</h1>
          {rightSlot ? <div className="cpPageHeaderSlot">{rightSlot}</div> : null}
        </div>

        <div className="cpPageMeta">
          Programme: <strong>{String(programmeName || 'Programme')}</strong>
        </div>

        {description ? <p>{description}</p> : null}
      </div>

      <div className="cpPageHeaderActions">
        <Button text={backText} customClass="btn-outline-secondary" onClick={onBackClick} />
      </div>
    </div>
  );
};
